var _path, _g, _path2, _path3, _path4, _g2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _circle, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1637 748",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 688h1600v4H0v-4z",
    fill: "#000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M468.6 202v118.3H398L468.6 202zm130 118.3h-48.2V94.1h-85.8L287 388.7h181.5V474h81.8v-85.3h48.2v-68.4zM658.6 283.8c0 130.5 47.6 196 142.1 196 53.4 0 91.7-20.9 112-58 20.8-37.1 29-80 29-138s-8.2-102.1-29-139.2c-20.3-37.2-58.6-58-112-58-94.5 0-142 65.5-142 197.2zm81.2 0c0-79 20.3-118.4 61-118.4 40 0 59.7 39.5 59.7 118.4 0 78.3-19.8 117.1-59.8 117.1-40.6 0-60.9-38.8-60.9-117.1zM1167.6 202v118.3h-70.8l70.8-118.3zm129.9 118.3h-48.1V94.1h-85.9L986 388.7h181.6V474h81.8v-85.3h48.1v-68.4z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M614.6 304.3v100.4h-48.2V490H452.6v-85.3H258.8L455.5 78.1h111v226.2h48zm-150-210.2h85.8v226.2h48.2v68.4h-48.2V474h-81.8v-85.3H287.1L464.6 94.1zm4 107.9L398 320.3h70.7V202zm-16 58l-26.5 44.3h26.5v-44.4zM681.3 440c-26.6-36.6-38.7-89.6-38.7-156.3 0-67.3 12-120.6 38.6-157.4 27.3-37.7 68.1-55.8 119.5-55.8 57.9 0 102.2 23 126 66.2 22.7 40.5 31 87.6 31 147 0 59.4-8.3 105.3-31 145.8-23.8 43.2-68.1 66.2-126 66.2-51.4 0-92.2-18.1-119.4-55.7zm231.4-295.5c20.8 37 29 81.2 29 139.2 0 58-8.2 100.9-29 138-20.3 37.1-58.6 58-112 58-94.5 0-142-65.5-142-196 0-131.7 47.5-197.2 142-197.2 53.4 0 91.7 20.8 112 58zm-143.4 57.7c-8.4 16.4-13.5 42.9-13.5 81.5 0 38.3 5 64.4 13.4 80.5 4.1 7.8 8.7 12.8 13.5 15.8 4.7 3 10.5 4.8 18 4.8a31 31 0 0017.5-4.7c4.7-3 9.2-8 13.1-15.8 8.2-16 13.2-42.3 13.2-80.6 0-38.7-5-65.2-13.2-81.6-4-8-8.5-13-13.2-16-4.5-3-10.1-4.8-17.4-4.8a32 32 0 00-18 4.9 40.4 40.4 0 00-13.4 16zm544.2 102v100.4h-48.1V490h-113.8v-85.3H957.7l196.8-326.6h110.9v226.2h48.1zm-150-210.2h85.9v226.2h48.1v68.4h-48.1V474h-81.8v-85.3H986l177.5-294.6zm4 107.9l-70.7 118.3h70.8V202zm-16 58l-26.5 44.3h26.6v-44.4zm-350.8-94.6c-40.6 0-60.9 39.5-60.9 118.4 0 78.3 20.3 117.1 61 117.1 40 0 59.7-38.8 59.7-117.1 0-79-19.8-118.4-59.8-118.4z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M884.6 443.8c8.6 1 32 6.3 46.7 18.3 11.6 9.5 38 36.8 49.3 81.5 13 51.6 15.9 96.6 13 123.3-2.1 21.2 1.5 40.3-29 58.6-21.7 13-130-1-149.7-11.6-22.7-12.2-24.6-16.3-25.9-21a306 306 0 01-5-111c6.7-41.6 24.9-96 42.2-119 15.5-20.6 42.8-21 58.4-19.1z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M889.6 609.5s21.7-12.1 34.7-18.4c2.4-1.2 3.2 28-1 27.9a90.7 90.7 0 01-33.7-9.5zM883.4 610s-22.4-10.5-36.5-11.3c-2.7-.2-1 30.9 3.2 29.5a124 124 0 0033.3-18.3zM862 551.9a85.6 85.6 0 0022.3 38s15.6-19.2 19.9-37.2M869.6 546.6c7.9-4.7 19-4.6 25.8-.3",
    stroke: "#000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M892.1 628.1c.5-1.6-.2-3.3-1.4-3.6-1.3-.4-2.6.7-3.1 2.4s.2 3.3 1.4 3.7c1.3.3 2.6-.8 3.1-2.5zM885 648c.7-1.3.4-2.8-.8-3.5-1.1-.6-2.6-.1-3.3 1.2-.8 1.2-.5 2.8.7 3.5 1 .6 2.6 0 3.3-1.2zM883.1 700.4c.9-1 .7-2.5-.4-3.5-1-1-2.6-1-3.5 0-.8 1-.7 2.5.4 3.5s2.7 1 3.5 0zM911.8 704.2c1-1.4.6-3.3-.7-4.1-1.3-.8-3-.3-4 1.2-1 1.4-.6 3.3.7 4.1 1.3.8 3 .3 4-1.2zM894.5 664.5a2.4 2.4 0 100-4.7 2.4 2.4 0 000 4.7zM892.2 703.4a2.4 2.4 0 100-4.7 2.4 2.4 0 000 4.7zM925.2 665.8c.5-1.6-.3-3.3-1.9-3.7-1.5-.5-3 .5-3.5 2.2-.5 1.7.4 3.4 1.9 3.8 1.5.4 3-.6 3.5-2.3z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M921.3 522.4c-.4.4-1 .6-1.6.6a2.7 2.7 0 01-1.6-4.8l-1-.2c-2.5-.2-4.9 2.4-5.1 6-.3 3.4 1.6 6.4 4.2 6.6 2.6.2 5-2.5 5.2-6l-.1-2.2zM851.2 522.9c-.5.4-1 .6-1.7.6a2.7 2.7 0 01-1.8-4.6c-2.6-.6-5.4 1.1-6.6 4.1-1.3 3.2-.2 6.8 2.4 7.8 2.7 1.1 6-.6 7.3-3.9.5-1.3.6-2.7.4-4z",
    fill: "#000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M899 612.6l9-12.2M867.4 619l8.9-12.2M857.1 625l13-19.2M849 626.7l15.5-23.4M845.6 620.6l12.8-20.2M845.6 608.8l6.4-9.5M903.5 614.5l20.2-21.7M909.7 617l16.5-16.3M917 617l9.1-8.2",
    stroke: "#000",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M910 736.9c12.8-2.3 18.6-2.2 24 .5 3.8 1.8 5.2 6.5-3.6 7.8a77.5 77.5 0 01-27.3-.4c-6.6-1.4-12-3.3-7.7-5.8M852.6 732.3c9.6-2 20.5-.4 26 2.5 3 1.6 6 4.8-2 6-7.6 1-18-.1-24-.8-5-.6-8.8-1-13-3.8-2.1-1.4-4.5-5.5.4-6.2",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M892.8 445.6l-50.7-5.3M809 491.7l26.5-43.5",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1073.7 579.2s9.2.6 14.7-3.7a24 24 0 001.7-12c-.6-7-3.3-10.8-3.3-10.8-12.4 9.2-32.5 12-32.5 12l-5 13.2 24.4 1.3z",
    stroke: "#000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1085.8 577.7s5.1 1.5 6.5 12c.6 3.7-.1 7.6-2.1 10.8 0 0-5.9-3.8-21-6.4-6.6-1.3-13.2-2-19.9-2.2-8.8-1.5-12.9-14.5-12.9-14.5s24.2 1 34.6 1.8c9.3.8 14.8-1.5 14.8-1.5z",
    stroke: "#000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1088.3 602.3a8 8 0 01-2.5 7.2c-5.5 5-10.5 5.7-10.5 5.7a48.5 48.5 0 00-25.4-14s-8.7-6-5.3-9.3h4.7s32 .7 39 10.4zM994.7 657c49-30 58.7-32.3 65.4-52M980.3 542.3s16.5 14.9 57.5 8.1",
    stroke: "#000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1039.2 546.4a37 37 0 0015.1-2.4c3.3 15.2 3.5 33.5 2.4 47.6a12.2 12.2 0 01-8.6-4.9c-10.4-14.8-12-38.6-9-40.3z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3c14 362 933 538 997 295",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.2 478.5l2.9 84.3 12.8-4.4-2.8-80.2a50 50 0 01-13 .3z",
    stroke: "#000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1029.8 471.3s-49 131.2-50.2 137.1c-2 6.5 14.5 12.2 16.6 7.4a10165 10165 0 0045.9-140.4 50 50 0 01-12.3-4.1z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1059.8 478.2c-2.7-1.3-2-8.9-.8-8.8 1.3.2 14.2 1 15.9-.2 1.7-1.2 3.2 7.7 1.5 8.4a46 46 0 01-16.6.6zM1028.6 470.4c-2-2 1.2-9 2.4-8.4 1.1.6 12.9 5.8 15 5.2 2-.5.3 8.4-1.6 8.5-1.8.1-13.7-3.2-15.8-5.3z",
    stroke: "#000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1055.6 453c1.3.3 5 7.8 5.5 16.6 0 0 10.2.8 12.2 0-.2-19.3-7-22.4-8.8-24.2l-.8 4.1-8.1 3.4z",
    stroke: "#000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1045.1 467.2c-2.6-.2-9.5-3.3-11.1-3.9 0 0 4.2-13 13.4-19.3 3-28.5 5.7-73.6 22.8-99.1 7 27.2.4 70.8-6.6 104.7-3.2 1.2-9.6 3.3-11.9 5-5 3.6-6.6 12.6-6.6 12.6z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1034 463.3l-.6 1.4a1.5 1.5 0 01-.9-1.9l1.5.5zm11.1 3.9l1.5.2-.2 1.3h-1.4l.1-1.5zm6.6-12.7l.9 1.3-.9-1.3zm11.9-5l1.4.4-.1.8-.8.3-.5-1.4zm6.6-104.6l-1.3-.8 2-2.8.8 3.2-1.5.4zm-22.8 99.1l1.5.2v.7l-.6.4-.9-1.3zm-13 17.9l2.2.9a138.8 138.8 0 006.3 2.4l2.3.5-.2 3a53.3 53.3 0 01-9.6-3.1l-2-.9 1-2.8zm10.7 5.3l-1.5-.3v-.1l.1-.3.3-1.2 1-3.6a18 18 0 015.8-8.4l1.8 2.5a15 15 0 00-4.7 7 30 30 0 00-1.3 4.5v.1l-1.5-.2zm5.7-13.9c1.4-1 3.7-2 6-2.8 2.4-1 4.6-1.7 6.2-2.3l1.1 2.8-6.3 2.3c-2.3 1-4.3 1.8-5.2 2.5l-1.8-2.5zm11.3-4c3.5-17 7-36.3 8.6-54.7a153 153 0 00-2-49.3l3-.8a156 156 0 012 50.4c-1.7 18.6-5.1 38-8.7 55l-2.9-.6zm-13.8-4c-4.3 3-7.6 7.5-9.7 11.5a51.2 51.2 0 00-3.2 7l-1.4-.5-1.5-.5.1-.1a41.5 41.5 0 013.3-7.3c2.3-4.2 5.8-9.2 10.7-12.6l1.7 2.5zm23.1-99.6c-8.3 12.5-13.2 29.9-16.4 47.9-3.2 18-4.6 36.3-6 50.6l-3-.3c1.4-14.2 2.9-32.7 6-50.8 3.3-18.1 8.2-36 17-49l2.4 1.6z",
    fill: "#000"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1056.6,
    cy: 437.6,
    r: 3.9,
    stroke: "#000",
    strokeWidth: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1070.1 344.8l-11.5 79.2",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1100.3 247.3l32.4-31.2M1100.3 298.4l34.6 28.6M1037.4 314.5l-17.8 41.3M1071.5 314.5l6 18.4M981.2 306.5l16.3-10.3M1074.5 235.6l1.5-19.3M1008.3 253.5L993.5 241M1003.7 273.8l-45-.1M1041 239.8l-7-37.3M1581 5c-24 102-212 375-472 273",
    stroke: "#000",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M933.9 523.8c.4 6-1.2 11-4 14.5-2.9 3.5-7 5.6-11.7 6-9.5.6-17.9-6.2-18.7-18.2-.8-12.2 6-21.2 15.3-21.9 9.4-.6 18.3 7.5 19 19.6zM828.7 523.8c-.4 6 1.2 11 4 14.5s7 5.6 11.7 6c9.4.6 17.9-6.2 18.7-18.2.8-12.2-6-21.2-15.4-21.9-9.3-.6-18.2 7.5-19 19.6z",
    stroke: "#000",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M651.1 648.5l3.3-6.6-20-12.1-8.6-7.3-9.4-13.1-4.6-10.8-5.3 5.8-6.9 4-9.7 2.6-12.5 1.9 2.5 9.6 1.1 25-1.1 25.6-3 25.1L598 687l18.4-10 22.1-16.3 12.6-12.1z",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M477.8 732.5c-32.5-1-79.3-3.2-87.6-3.8-10.4-.7-19.3-21.3-20-44.4-1-43.3-1.8-87 20-106.5 23.5-21 45.7-23.7 85.4-23.4 33.7.3 68.8 4 90 29.6 17.5 21.3 16.3 68.2 13.8 94.2-3 31.1-9 53-20 53.9-11 .8-42.6 1.6-81.6.4z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M495.6 554.9s7.3-5 8.4-8.4c1-3.3.6-5.5.6-5.5M502.5 554.3s2.4-3 7-6c2.4-1.4 5.3-2 5.3-2",
    stroke: "#000",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M494 602l104.5 3.4M361.1 592l111.5 10",
    stroke: "#000",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M594.9 605.3l-2.6 43-93.9-4.6",
    stroke: "#000",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M455.3 641l-97-5.7L361 592",
    stroke: "#000",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M426.4 604.2c-.7 4.7-7.6 9.3-15.6 8.5-8-.7-13.7-6.3-13.2-11.1.8-8.2 7.5-6.7 15.5-6 8 .8 14.6.7 13.3 8.6zM559.2 610.9c-.7 4.7-7.6 9.2-15.6 8.5-8-.7-13.7-6.4-13.2-11.2.8-8.1 7.5-6.6 15.5-5.9 8 .7 14.6.6 13.3 8.6z",
    fill: "#000"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M482.6 620.5c-3.8-.7-10.1-1-15.2.6-4.1 1.2-6.6 3.5-6.6 3.5 6 22.8 16 27.9 16 27.9S494 641 493 626.8M411.4 730.7s2.5 6.7 8 7.6c5.3 1 19.1 1.4 24.2.4 4.1-.9 5.6-6.6 5.6-6.6M510.4 733.8s1.8 5.2 7.2 6.2 19.2 1 24.2 0c4.2-.8 6-6.9 6-6.9",
    stroke: "#000",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M650.5 614s31.4-22.7 42-36.5c3.8-5.2 3.5-16.8-2.7-18.2-18.2 16-52 43.6-59.9 47.3l-.7 12.7 21.3-5.3z",
    stroke: "#000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M660.5 609.5s4.8 0 8.7 8.6c1.5 3 1.9 6.5 1 9.9 0 0-6-1.8-19.7 0-6 .6-11.8 1.8-17.6 3.4-8 1-15-9.2-15-9.2s21.1-5.4 30.2-7.5a30.5 30.5 0 0012.4-5.2z",
    stroke: "#000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M669.1 630a7.2 7.2 0 01-.3 6.8c-3.4 5.8-7.5 7.7-7.5 7.7-12.2-7.2-25.5-5.3-25.5-5.3s-9-2.8-7-6.6l4-1.2s27.8-8 36.3-1.4z",
    stroke: "#000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M612.1 594.9a33.3 33.3 0 0012.4-6 158.4 158.4 0 0114.6 40.2 11 11 0 01-8.7-2c-12.9-10-20.5-29.9-18.3-32.2z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M655 642.3c-8.7 17.7-45.7 40-77.5 55.5M612 598.3c-5 12.7-34.7 14-34.7 14",
    stroke: "#000",
    strokeWidth: 3
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M231.6 156.3h7.6c4.8 0 8.5-1.4 11.2-4.3 2.6-2.9 3.9-6.3 3.9-10.4a14.4 14.4 0 00-15.1-14.7h-18.3V171h10.7v-14.7zm7-20c6.5-.4 6.5 11 0 10.8h-7v-10.9h7zM297 171L281 126.9h-11.7L253 171h11.4l3.8-10.1H282l3.8 10.1H297zm-17.7-19.3H271l4-14.6 4.3 14.6zM338 134.1a22 22 0 00-17.2-7.8 22 22 0 00-16.2 6.7 21.7 21.7 0 00-6.5 16c0 6.2 2.1 11.6 6.5 16a22 22 0 0016.2 6.6c6.6 0 12-2 15.8-6 4-4 6-10 6-18.2h-24v8.6h12.3c-1 3.9-4.3 5.8-10.1 5.8a11 11 0 01-8.5-3.7 13.1 13.1 0 01-3.4-9.1c0-3.5 1.1-6.5 3.4-9a11.6 11.6 0 0117.7.9l8-6.8zM378.1 161.7h-18.5v-7.9h15.8v-9.1h-15.8v-8.5h18V127h-28.7V171h29.2v-9.3zM424.2 150.6L411 127h-9.6V171H412v-24l13.5 24h9.3v-44.1h-10.7v23.7zM442.2 149c0 6.2 2.2 11.6 6.6 16 4.5 4.4 9.7 6.6 16 6.6 6.2 0 11.5-2.2 15.8-6.6 4.5-4.4 6.6-9.8 6.6-16 0-6.3-2.1-11.6-6.6-16a21.6 21.6 0 00-15.9-6.7c-6.2 0-11.5 2.3-16 6.7a22 22 0 00-6.5 16zm22.5 11.8a11 11 0 01-8.2-3.4 11.6 11.6 0 01-3.4-8.4c0-3.3 1.1-6.1 3.4-8.4 2.2-2.4 5-3.5 8.2-3.5 3.3 0 6 1.1 8.3 3.5 2.3 2.3 3.5 5.1 3.5 8.4 0 3.2-1.2 6-3.5 8.4-2.2 2.3-5 3.4-8.3 3.4zM502 171h10.6v-34.8H524V127h-33.5v9.3H502V171zM555 154h13.9v-9.3h-14v-8.5h17.6V127h-28.3V171H555v-17zM576.2 149c0 6.2 2.2 11.6 6.6 16 4.4 4.4 9.6 6.6 15.8 6.6 6.3 0 11.6-2.2 16-6.6 4.4-4.4 6.6-9.8 6.6-16 0-6.3-2.2-11.6-6.6-16a21.6 21.6 0 00-16-6.7c-6.2 0-11.5 2.3-15.9 6.7a22 22 0 00-6.5 16zm22.4 11.8a11 11 0 01-8.2-3.4 11.6 11.6 0 01-3.4-8.4c0-3.3 1.1-6.1 3.4-8.4 2.2-2.4 5-3.5 8.2-3.5 3.3 0 6 1.1 8.4 3.5 2.3 2.3 3.4 5.1 3.4 8.4 0 3.2-1.1 6-3.4 8.4-2.3 2.3-5 3.4-8.4 3.4zM628 155c0 4.9 1.8 8.8 5.2 12 3.4 3 7.5 4.6 12.2 4.6 4.8 0 8.9-1.6 12.3-4.6 3.4-3.2 5.2-7.1 5.2-12v-28.1H652v28c0 2-.7 3.6-2 4.8a6.7 6.7 0 01-9.3 0 6.1 6.1 0 01-2-4.8v-28H628v28zM695 150.6L681.8 127h-9.6V171h10.7v-24l13.5 24h9.3v-44.1H695v23.7zM733 136.4c3 0 5.3 1.3 6.9 3.8 1.6 2.4 2.5 5.3 2.5 8.8 0 3.5-.9 6.4-2.5 8.9a7.8 7.8 0 01-6.9 3.6h-6.7v-25h6.7zm0 34.6c6.2 0 11.2-2 14.7-6.1 3.6-4.2 5.4-9.5 5.4-15.9s-1.8-11.7-5.4-15.8a18.3 18.3 0 00-14.7-6.3h-17.4V171H733z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.da560cf3d0e69d73762fb29048efee64.svg";
export { ForwardRef as ReactComponent };